// GoogleCalendarIcon.tsx
// A reusable SVG component for the Google Calendar icon
import React from 'react'

const GoogleCalendarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g>
         <path
            fill="#4285F4"
            d="M21.6 12.227c0-.81-.073-1.62-.227-2.407H12v4.56h5.37a4.59 4.59 0 01-1.98 3.01v2.49h3.19c1.87-1.72 2.95-4.26 2.95-7.653z"
         />
         <path
            fill="#34A853"
            d="M12 22c2.43 0 4.47-.8 5.96-2.17l-3.19-2.49c-.89.6-2.03.96-3.27.96-2.51 0-4.64-1.7-5.4-3.98H3.77v2.53A9.99 9.99 0 0012 22z"
         />
         <path
            fill="#FBBC05"
            d="M6.6 14.32A5.99 5.99 0 016.13 12c0-.81.14-1.6.38-2.32V7.15H3.77A9.99 9.99 0 002 12c0 1.62.39 3.16 1.77 4.85l2.83-2.53z"
         />
         <path
            fill="#EA4335"
            d="M12 6.54c1.32 0 2.5.45 3.43 1.33l2.57-2.57C16.47 3.8 14.43 3 12 3A9.99 9.99 0 003.77 7.15l2.83 2.53c.76-2.28 2.89-3.98 5.4-3.98z"
         />
      </g>
   </svg>
)

export default GoogleCalendarIcon
